import React from "react"
import { Button, InternalIcon, Link, Stack, Tile, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as ReactRouterLink } from "react-router-dom"
import { Paths } from "#/utils/Paths"

export function ClinicalTreatmentTile(): JSX.Element {
  return (
    <Tile variant="secondary" color="green">
      <Stack gap={(theme) => theme.tokens.spacing.md}>
        <Typography variant="h4" component="h2">
          <FormattedMessage defaultMessage="Get clinical treatment" />
        </Typography>
        <Typography>
          <FormattedMessage defaultMessage="Carrot clinicians who can diagnose and prescribe treatment." />
        </Typography>
        <Button
          component={ReactRouterLink}
          to={{ pathname: Paths.TELEMEDICINE, state: { insuranceEntry: true, returnTo: "/care-team" } }}
          variant="outlined"
          color="secondary"
          fullWidth={false}
          sx={{ alignSelf: "flex-start", inlineSize: "fit-content" }}
        >
          <FormattedMessage defaultMessage="Check insurance" />
        </Button>
        <Link
          component={ReactRouterLink}
          to={{ pathname: Paths.TELEMEDICINE, state: { returnTo: "/care-team" } }}
          underline="hover"
          endIcon={<InternalIcon color="primary" fontSize="small" />}
          sx={{ alignSelf: "flex-start" }}
        >
          <FormattedMessage defaultMessage="Self pay" />
        </Link>
      </Stack>
    </Tile>
  )
}
